(() => {
  const $mobileNavWrap = $('.mobile-header__wrap')
  const $mobileDropdownTrigger = $('.mobile-header__menu-icon')
  const $mobileDropdownsWrap = $('.main-menu-mobile__dropdowns')
  const $mobileSearchTrigger = $('.mobile-header__search')
  const $mobileSearchWrap = $('.mobile-header__search-bar')

  $mobileDropdownTrigger.on('click', () => {
    $mobileSearchTrigger.removeClass('is-open')
    $mobileSearchWrap.removeClass('is-open')

    if ($mobileDropdownTrigger.hasClass('is-open')) {
      $mobileDropdownTrigger.removeClass('is-open')
      $mobileNavWrap.removeClass('is-open')
      $mobileDropdownsWrap.removeClass('is-open')
    } else {
      $mobileDropdownTrigger.addClass('is-open')
      $mobileNavWrap.addClass('is-open')
      $mobileDropdownsWrap.addClass('is-open')
    }
  })

  $mobileSearchTrigger.on('click', () => {
    $mobileDropdownTrigger.removeClass('is-open')
    $mobileNavWrap.removeClass('is-open')
    $mobileDropdownsWrap.removeClass('is-open')

    if ($mobileSearchTrigger.hasClass('is-open')) {
      $mobileSearchTrigger.removeClass('is-open')
      $mobileSearchWrap.removeClass('is-open')
    } else {
      $mobileSearchTrigger.addClass('is-open')
      $mobileSearchWrap.addClass('is-open')
    }
  })

  const subcategoryDropdowns = [...document.querySelectorAll('.main-menu-mobile__dropdown')]
    .filter((dropdown) => dropdown.querySelector('.main-menu-mobile__subcategory-wrap--has-dropdown'))
    .map((dropdown) => ({
      el: dropdown,
      accordion: new Accordion(dropdown, {
        elementClass: 'main-menu-mobile__subcategory-wrap--has-dropdown',
        triggerClass: 'main-menu-mobile__dropdown__subcategory-icon',
        panelClass: 'main-menu-mobile__dropdown__subcategory-items',
        activeClass: 'is-open',
      }
    )}))

  new Accordion('.main-menu-mobile__dropdowns', {
    elementClass: 'main-menu-mobile__dropdown-wrap--has-dropdown',
    triggerClass: 'main-menu-mobile__category-icon',
    panelClass: 'main-menu-mobile__dropdown',
    activeClass: 'is-open',
    beforeClose: (el) => {
      const panelId = el.id.split('-').join('-panel-')
      const subcategoryDropdown = subcategoryDropdowns.find((dropdown) => dropdown.el.id === panelId)

      if (!subcategoryDropdown) return

      subcategoryDropdown.accordion.closeAll()

      // Below we are manually toggling false aria-expanded's due to a bug with
      // manually closing dropdowns with accordion-js
      const expandedAreas = [...subcategoryDropdown.el.querySelectorAll('[aria-expanded="true"]')]
      if (expandedAreas) {
        expandedAreas.forEach((expanded) => expanded.setAttribute('aria-expanded', false))
      }
    }
  })
})()